module.exports = __webpack_public_path__ + "media/assets/images/favicon-011c624ae7c8b28059911ac6ed3906c5.ico";